<template>
  <div class="modal fade" :id="this.modalName" tabindex="-1" :aria-labelledby="this.modalName" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header p-5">
          <h5 class="modal-title" :id="this.modalName+'Label'" v-html="this.title"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-5">
          <slot name="body"/>
        </div>
        <div class="modal-footer p-2 justify-content-center">
          <slot name="footer"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StandardModal',
  props: {
    modalName: null,
    title:     null
  }
}
</script>

<style scoped>

</style>